import smartLogoSymbol from './smart-logo-symbol.svg';
import smartLogoVertical from './smart-logo-vertical.svg';
import smartLogoWordmark from './smart-logo-wordmark.svg';

export const LogoNames = {
  'smart-logo-symbol': smartLogoSymbol,
  'smart-logo-vertical': smartLogoVertical,
  'smart-logo-wordmark': smartLogoWordmark
} as const;

export type LogoType = keyof typeof LogoNames;
